import { useTableActionContext } from '@aibees/elephant/context';
import { useBoolean } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { Box } from '@mui/material';
import { memo, useState } from 'react';
import { QuickActionMenuItem } from '../quick-action-menu-item';
import { QuickActionsButtonGroupIntegrationMenu } from '../quick-actions-button-group-integration-menu';
import * as Styled from './styles';
import * as SX from './sx';
import type { QuickActionsButtonGroupExportMenuProps as Props } from './types';

const ANCHOR_ORIGIN = {
  vertical: 'top',
  horizontal: 'right',
} as const;
const TRANSFORM_ORIGIN = {
  vertical: 'top',
  horizontal: 'left',
} as const;

export const QuickActionsButtonGroupExportMenu = memo(
  ({ className, state, anchorEl, handleClose }: Props) => {
    const { exportDialogState } = useTableActionContext();
    const [integrationAnchorEl, setIntegrationAnchorEl] =
      useState<HTMLDivElement | null>(null);
    const integrationMenuOpen = useBoolean();

    const handleCloseMainMenu = () => {
      state.onFalse();
    };

    const handleClickExport = () => {
      exportDialogState.onTrue();
      handleClose?.();
    };

    return (
      <Styled.Wrapper
        className={classnames('QuickActionsButtonGroupExportMenu', className)}
        anchorEl={anchorEl}
        open={state.value}
        onClose={handleCloseMainMenu}
        anchorOrigin={ANCHOR_ORIGIN}
        transformOrigin={TRANSFORM_ORIGIN}
        padding="normal"
      >
        <Box sx={SX.root}>
          <QuickActionMenuItem title="CSV Files" onClick={handleClickExport} />

          <QuickActionMenuItem
            title="Integrations"
            onClick={(e) => {
              setIntegrationAnchorEl(e.currentTarget);
              integrationMenuOpen.onTrue();
            }}
            hasChildren
            childState={integrationMenuOpen}
          />
        </Box>
        <QuickActionsButtonGroupIntegrationMenu
          state={integrationMenuOpen}
          anchorEl={integrationAnchorEl}
          handleClose={handleClose}
        />
      </Styled.Wrapper>
    );
  }
);

QuickActionsButtonGroupExportMenu.displayName =
  'QuickActionsButtonGroupExportMenu';
